// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2xbs4","modalForm":"UpgradeEpcsModal_modalForm__1VdR1","modalFooter":"UpgradeEpcsModal_modalFooter__1PIxV"};